module.exports = __webpack_public_path__ + "img/icon_1.a6d1eb7.png";